import { useState, useEffect, memo, useCallback } from "react";
import { CSVLink } from "react-csv";
import AnimacionCarga from "../components/animacion_de_carga";
import BarraSuperior from "../components/barra_superior";
import TablaGenerica from "../components/tablas";
import { obtenerNotificaciones } from "../../functions/consultas";
import Swal from "sweetalert2";
import { subirArchivoFirebase } from "../../functions/archivos_firebase";
import { crearRegistro, eliminarRegistro } from "../../functions/crud";
import BotonSOS from "../components/sos/boton_sos";
import "bootstrap-icons/font/bootstrap-icons.css";


const COLUMNAS = [
  { label: "Fecha",       key: "fechaPublicacion" },
  { label: "Título",      key: "titulo"           },
  { label: "Descripción", key: "comentario"       },
  { label: "Imagen",      key: "urlImagen"        },
  { label: "Tipo",        key: "tipoProgramacion" },
];

const IMAGEN_DEFAULT = "https://firebasestorage.googleapis.com/v0/b/coordiph-2.appspot.com/o/RecursosPlantillas%2Fcoordi_logo.png?alt=media";
const API_URL        = "https://coordiph.herokuapp.com/notificaciones/nuevapush";
const LOCALE_CO      = { year: "numeric", month: "long", day: "numeric" };

const estiloCSV = { padding: "7px 14px", margin: 2, backgroundColor: "#c0392b", color: "#fff", borderRadius: 7, fontSize: "0.82rem", fontWeight: 500, textDecoration: "none" };


const formatFecha = (fecha) =>
  fecha ? new Date(fecha).toLocaleDateString("es-CO", LOCALE_CO) : "";

const useEsMobil = () => {
  const [es, setEs] = useState(window.innerWidth < 700);
  useEffect(() => {
    const fn = () => setEs(window.innerWidth < 700);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return es;
};


const SWAL_ESTILOS = `<style>
  .swal2-input,.swal2-textarea,.swal2-file{
    margin:0!important;width:100%!important;box-sizing:border-box!important;
    padding:10px!important;border:1px solid #d1d5db!important;
    border-radius:5px!important;font-size:14px!important;
  }
  .swal2-textarea{min-height:100px!important;resize:vertical!important;}
</style>`;

const formularioHTML = () => `
  ${SWAL_ESTILOS}
  <div style="text-align:left;padding:20px;">
    <h3 style="margin:0 0 25px;color:#2c3e50;font-size:20px;font-weight:600;">Nueva Notificación Push</h3>
    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Título</label>
      <input id="titulo" class="swal2-input" placeholder="Título de la notificación">
    </div>
    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Mensaje</label>
      <textarea id="descripcion" class="swal2-textarea" placeholder="Escribe el mensaje aquí..."></textarea>
    </div>
    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Imagen o Video (opcional)</label>
      <input id="archivo" type="file" accept="image/*,video/*" class="swal2-file">
    </div>
    <div id="preview" style="margin-top:20px;text-align:center;"></div>
  </div>`;

const attachPreview = () => {
  const archivo = document.getElementById("archivo");
  const preview = document.getElementById("preview");
  archivo.addEventListener("change", () => {
    const file = archivo.files[0];
    if (!file) { preview.innerHTML = ""; return; }
    const url     = URL.createObjectURL(file);
    const esVideo = file.type.startsWith("video/");
    preview.innerHTML = `<div style="background:#f8f9fa;padding:15px;border-radius:8px;border:2px dashed #d1d5db;">
      ${esVideo
        ? `<video controls src="${url}" style="max-width:100%;max-height:250px;border-radius:6px;display:block;margin:0 auto;"></video>`
        : `<img src="${url}" style="max-width:100%;max-height:250px;border-radius:6px;display:block;margin:0 auto;">`
      }
    </div>`;
  });
};

const validarFormulario = () => {
  const titulo      = document.getElementById("titulo").value.trim();
  const descripcion = document.getElementById("descripcion").value.trim();
  const archivo     = document.getElementById("archivo").files[0];
  if (!titulo || !descripcion) { Swal.showValidationMessage("Título y mensaje son obligatorios"); return false; }
  return { titulo, descripcion, archivo };
};

const abrirFormulario = () =>
  Swal.fire({
    title:             "Crear Notificación",
    html:              formularioHTML(),
    didOpen:           attachPreview,
    showCancelButton:  true,
    confirmButtonText: "Enviar",
    cancelButtonText:  "Cancelar",
    width: 600,
    preConfirm:        validarFormulario,
  });




const BtnNav = ({ onClick, disabled, children }) => (
  <button onClick={onClick} disabled={disabled} style={{
    width: 40, height: 40, borderRadius: "50%", fontSize: 18,
    border: "1px solid #d1d5db",
    background: disabled ? "#f3f4f6" : "#fff",
    color:      disabled ? "#d1d5db" : "#374151",
    cursor:     disabled ? "default"  : "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
  }}>{children}</button>
);

const BtnAccion = ({ onClick, borde, fondo, color, children }) => (
  <button onClick={onClick} style={{
    padding: "6px 14px", fontSize: 13, borderRadius: 6, cursor: "pointer",
    border: `1px solid ${borde}`, background: fondo, color,
  }}>{children}</button>
);

const ModalNotificacion = ({ notif, onCerrar }) => {
  if (!notif) return null;
  return (
    <div onClick={onCerrar} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9999, padding: 20,
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "#fff", borderRadius: 16, overflow: "hidden",
        width: "100%", maxWidth: 900, boxShadow: "0 8px 40px rgba(0,0,0,0.3)",
        display: "flex", flexDirection: "column",
      }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderBottom: "1px solid #e5e7eb" }}>
          <span style={{ color: "#1f2937", fontWeight: 600, fontSize: 16, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {notif.titulo}
          </span>
          <button onClick={onCerrar} style={{ background: "none", border: "none", color: "#6b7280", fontSize: 24, cursor: "pointer", lineHeight: 1, padding: "0 4px" }}>×</button>
        </div>
        <img src={notif.urlImagen || IMAGEN_DEFAULT} alt={notif.titulo}
          style={{ width: "100%", maxHeight: "65vh", objectFit: "contain", display: "block", background: "#f3f4f6" }} />
        <div style={{ padding: "16px 20px", borderTop: "1px solid #e5e7eb" }}>
          <p style={{ margin: 0, color: "#6b7280", fontSize: 14, lineHeight: 1.6 }}>{notif.comentario}</p>
          <span style={{ fontSize: 12, color: "#9ca3af", marginTop: 8, display: "block" }}>
            {formatFecha(notif.fechaPublicacion)}
          </span>
        </div>
      </div>
    </div>
  );
};

const TarjetaNotificacion = ({ notif, esMobil, esResidente, onVerMedia, onEliminar }) => (
  <div style={{
    background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16,
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)", width: "100%", maxWidth: 1500,
    overflow: "hidden", display: "flex", flexDirection: esMobil ? "column" : "row",
  }}>
    <div style={esMobil ? { width: "100%", aspectRatio: "16/9", flexShrink: 0 } : { width: 380, minWidth: 380, flexShrink: 0 }}>
      {notif.urlImagen ? (
        <img src={notif.urlImagen} alt={notif.titulo}
          style={{ width: "100%", height: "100%", minHeight: esMobil ? 0 : 240, objectFit: "cover", display: "block" }} />
      ) : (
        <div style={{ width: "100%", height: "100%", minHeight: esMobil ? 180 : 240, background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ fontSize: 64 }}>🔔</span>
        </div>
      )}
    </div>

    <div style={{ flex: 1, padding: esMobil ? 16 : "24px 28px", display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: esMobil ? "flex-start" : "flex-end" }}>
        {notif.urlImagen && (
          <BtnAccion onClick={() => onVerMedia(notif)} borde="#d1d5db" fondo="#fff" color="#374151">Vista Previa</BtnAccion>
        )}
        {!esResidente && (
          <BtnAccion onClick={() => onEliminar(notif)} borde="#fca5a5" fondo="#fef2f2" color="#dc2626">× Eliminar</BtnAccion>
        )}
      </div>
      <h3 style={{ margin: 0, fontSize: esMobil ? 17 : 20, fontWeight: 700, color: "#1f2937", lineHeight: 1.3 }}>
        {notif.titulo}
      </h3>
      <p style={{ margin: 0, fontSize: esMobil ? 14 : 15, color: "#6b7280", lineHeight: 1.7, flex: 1 }}>
        {notif.comentario}
      </p>
      <div style={{ borderTop: "1px solid #f3f4f6", paddingTop: 12, marginTop: "auto" }}>
        <span style={{ fontSize: 13, color: "#9ca3af" }}>{formatFecha(notif.fechaPublicacion)}</span>
      </div>
    </div>
  </div>
);


const ListadoNotificaciones = memo(() => {
  const [datos,        setDatos]        = useState([]);
  const [cargando,     setCargando]     = useState(true);
  const [indiceActual, setIndiceActual] = useState(0);
  const [modalNotif,   setModalNotif]   = useState(null);

  const esMobil     = useEsMobil();
  const esResidente = localStorage.getItem("Permisos") === "RESIDENTE";
  const nit         = localStorage.getItem("CodigoCliente");

  const cargar = useCallback(async () => {
    try {
      const data = await obtenerNotificaciones();
      const lista = Object.entries(data || {})
        .map(([id, item]) => ({ id, ...item }))
        .sort((a, b) => new Date(b.fechaPublicacion) - new Date(a.fechaPublicacion));
      setDatos(lista);
      setIndiceActual(0);
    } catch (e) {
      console.error("Error al obtener notificaciones:", e);
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const crearNotificacion = useCallback(async () => {
    const { value } = await abrirFormulario();
    if (!value) return;
    try {
      let urlImagen = null;
      if (value.archivo) {
        const nombre = `${Date.now()}_${value.archivo.name}`;
        urlImagen = await subirArchivoFirebase(`notificaciones/${nit}/${nombre}`, value.archivo);
      }
      const payload = {
        titulo:           value.titulo,
        comentario:       value.descripcion,
        urlImagen:        urlImagen || IMAGEN_DEFAULT,
        fechaPublicacion: new Date().toISOString().substring(0, 10),
        idConjunto:       nit,
        repetirCada:      "1",
        tipoProgramacion: "Ahora",
      };
      await fetch(API_URL, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
      await crearRegistro(`coordi_ph_clientes/${nit}/fcm_list`, {
        ...payload,
        fechaPublicacion: new Date().toISOString(),
        urlImagen:        urlImagen ?? null,
        usuario:          localStorage.getItem("CorreoElectronico"),
      });
      Swal.fire("Éxito", "Notificación enviada correctamente", "success");
      cargar();
    } catch (e) {
      console.error("Error al crear notificación:", e);
      Swal.fire("Error", "No se pudo enviar la notificación", "error");
    }
  }, [nit, cargar]);

  const eliminarNotificacion = useCallback(async (notif) => {
    const { isConfirmed } = await Swal.fire({
      title: "¿Eliminar Notificación?",
      html: `<div style="text-align:left;padding:15px;">
        <div style="background:#f8f9fa;padding:15px;border-radius:8px;border-left:4px solid #e74c3c;">
          <strong style="display:block;margin-bottom:8px;color:#2c3e50;">${notif.titulo}</strong>
          <p style="color:#7f8c8d;margin:0;font-size:14px;">${notif.comentario}</p>
        </div>
        <p style="margin-top:15px;color:#e74c3c;">Esta acción no se puede deshacer</p>
      </div>`,
      icon: "warning", showCancelButton: true,
      confirmButtonColor: "#d33", confirmButtonText: "Eliminar", cancelButtonText: "Cancelar",
    });
    if (!isConfirmed) return;
    try {
      await eliminarRegistro(`coordi_ph_clientes/${nit}/fcm_list/${notif.id}`);
      Swal.fire({ title: "Eliminada", text: "Notificación eliminada correctamente", icon: "success", timer: 2000, showConfirmButton: false });
      cargar();
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "No se pudo eliminar la notificación", "error");
    }
  }, [nit, cargar]);

  if (cargando) return <AnimacionCarga />;

  if (!esResidente) return (
    <>
      <BarraSuperior />
      <TablaGenerica
        datos={datos}
        titulos={COLUMNAS.map(c => c.label.toUpperCase())}
        campos={COLUMNAS.map(c => c.key)}
        mostrarBarraSuperior={false}
        columnaOrdenInicial={0}
        direccionOrdenInicial="desc"
        botones={[{ texto: "Eliminar", icono: "bi-trash", accion: eliminarNotificacion }]}
        contenidoExtra={
          <>
            <button onClick={cargar} title="Refrescar"><i className="bi bi-arrow-clockwise" /></button>
            <CSVLink data={datos} headers={COLUMNAS} filename="listado_notificaciones.csv" separator=";" style={estiloCSV} title="Exportar"><i className="bi bi-download" /></CSVLink>
            <button onClick={crearNotificacion} title="Nueva Notificación"><i className="bi bi-plus-lg" /></button>
          </>
        }
      />
      <BotonSOS />
    </>
  );

  const notif = datos[indiceActual];

  return (
    <>
      <BarraSuperior />
      <ModalNotificacion notif={modalNotif} onCerrar={() => setModalNotif(null)} />

      <div style={{ padding: "20px 16px 100px", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
        {datos.length === 0 && (
          <div style={{ position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <p style={{ color: "#888", fontSize: 15 }}>No hay notificaciones disponibles.</p>
          </div>
        )}
        {notif && (
          <TarjetaNotificacion
            notif={notif}
            esMobil={esMobil}
            esResidente={esResidente}
            onVerMedia={setModalNotif}
            onEliminar={eliminarNotificacion}
          />
        )}
      </div>

      {datos.length > 1 && (
        <div style={{
          position: "fixed", bottom: 20, left: "50%", transform: "translateX(-50%)",
          display: "flex", alignItems: "center", gap: 16,
          background: "rgba(255,255,255,0.95)", backdropFilter: "blur(6px)",
          border: "1px solid #e5e7eb", borderRadius: 50,
          padding: "10px 20px", boxShadow: "0 4px 16px rgba(0,0,0,0.12)", zIndex: 900,
        }}>
          <BtnNav onClick={() => setIndiceActual(i => Math.max(0, i - 1))} disabled={indiceActual === 0}>‹</BtnNav>
          <span style={{ fontSize: 13, color: "#9ca3af", minWidth: 60, textAlign: "center" }}>
            {indiceActual + 1} de {datos.length}
          </span>
          <BtnNav onClick={() => setIndiceActual(i => Math.min(datos.length - 1, i + 1))} disabled={indiceActual === datos.length - 1}>›</BtnNav>
        </div>
      )}

      <BotonSOS />
    </>
  );
});

export default ListadoNotificaciones;
